import { colors } from 'kaizen-ui-colors/lib';
import * as React from 'react';
import styled from 'styled-components';
import { ListItemAvatar, ListItemText } from './base/List';
import Avatar from './base/Avatar';

interface IOrganizationListItemProps {
  name: string;
  profileImageUrl: string;
  currentOrganization: boolean;
}

const OrganizationItem = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

class OrganizationListItem extends React.PureComponent<IOrganizationListItemProps, {}> {
  public render() {
    const { name, profileImageUrl, currentOrganization } = this.props;

    let color;
    if (currentOrganization) {
      color = { color: colors.veggie__2dcc70 };
    }

    return (
      <OrganizationItem style={color}>
        <ListItemAvatar>
          <Avatar src={profileImageUrl} username={name} type={'organization'} />
        </ListItemAvatar>
        <ListItemText>{name}</ListItemText>
      </OrganizationItem>
    );
  }
}

export default OrganizationListItem;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/OrganizationListItem.tsx